<nz-card class="round-border p-4" [nzLoading]="!loaded">
    <a [routerLink]="['/point-of-interest']">
        <nz-statistic [nzValue]="count | number" [nzTitle]="'point-of-interest_common_name' | translate"></nz-statistic>
    </a>
</nz-card>